module.exports = new __parcel__URL__("trophy_icon_small.74cabef8.png").toString();